var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"width":"100vw"},attrs:{"id":"UIdesignproject"}},[_c('div',{attrs:{"id":"a1eda944"}},[_vm._v(" 设计中列表 ")]),_c('div',{attrs:{"id":"b72e119c"}},[_c('dal-comp-design',{attrs:{"id":"cmpb72e119c"}})],1),_c('el-pagination',{attrs:{"id":"ce7cfbd9"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }